import { render, staticRenderFns } from "./BalanceManage.vue?vue&type=template&id=57ebc8c2&scoped=true"
import script from "./BalanceManage.vue?vue&type=script&lang=js"
export * from "./BalanceManage.vue?vue&type=script&lang=js"
import style0 from "./BalanceManage.vue?vue&type=style&index=0&id=57ebc8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ebc8c2",
  null
  
)

export default component.exports